export interface Address {
  street: string
  city: string
  code: string
  country: string
  url?: string
}

export const ADDRESS_KARLSTAD: Address = {
  street: "Våxnäsgatan 148",
  city: "Karlstad",
  code: "653 43",
  country: "Sweden",
  url: "https://maps.app.goo.gl/3DXh4oYUKXtASV6R8",
}

export const ADDRESS_GOTHENBURG: Address = {
  street: "Nellickevägen 22",
  code: "412 63",
  country: "Sweden",
  city: "Göteborg",
  url: "https://maps.app.goo.gl/PMhAtaB7xyJMxx5S7",
}

export const ADDRESS_USA: Address = {
  street: "250 W. Pennsylvania Ave",
  city: "Southern Pines, NC",
  country: "USA",
  code: "28387",
  url: "https://maps.app.goo.gl/vvLDGZCWAcG32niF6",
}
